import { Box } from '@mui/material';
import { CardDemonstrationBlur } from 'src/components/CardDemonstration';
import Subtitle from 'src/components/Subtitle';
import { useAuthContext } from 'src/context/AuthContextProvider';

import { AmortizationRedemptionsCharts } from './AmortizationRedemptionsCharts';
import { EmissionCharts } from './EmissionCharts';
import { NetAssetValueUnitCharts } from './NetAssetValueUnitCharts';
import { ProfitabilityTableAndCharts } from './ProfitabilityTableAndCharts';
import { QuotaValuesCharts } from './QuotaValuesCharts';
import { SubordinationCharts } from './SubordinationCharts';

export function DailyQuotaCharts({ hashId }: { hashId: string }) {
  const { auth } = useAuthContext();
  const userPlanType = auth.user?.subscription?.plan?.type;
  const isVipPlan = userPlanType?.toLocaleLowerCase() === 'vip';

  return (
    <Box>
      <QuotaValuesCharts hashId={hashId} />
      <NetAssetValueUnitCharts hashId={hashId} />
      <EmissionCharts hashId={hashId} />
      <AmortizationRedemptionsCharts hashId={hashId} />

      <CardDemonstrationBlur
        allow={isVipPlan}
        title="Recurso disponível apenas no plano VIP"
        subTitle="Faça um upgrade em sua assinatura para ter acesso a esse recurso."
        labelButton="Fazer upgrade"
        url="/planos"
        subtitleComponent={<Subtitle title="Rentabilidade diária" />}>
        <ProfitabilityTableAndCharts
          hashId={hashId}
          hasPermission={isVipPlan}
        />
      </CardDemonstrationBlur>

      <CardDemonstrationBlur
        allow={isVipPlan}
        title="Recurso disponível apenas no plano VIP"
        subTitle="Faça um upgrade em sua assinatura para ter acesso a esse recurso."
        labelButton="Fazer upgrade"
        url="/planos"
        subtitleComponent={<Subtitle title="Subordinação" />}>
        <SubordinationCharts hashId={hashId} hasPermission={isVipPlan} />
      </CardDemonstrationBlur>
    </Box>
  );
}
